import { z } from "zod";

import { MAX_ASSIGNEES } from "@/features/tasks/hooks/useAssigneeOptions";
import { BOARD_COLUMNS, TASK_TITLE_MAX_LENGTH } from "@/features/tasks/lib/board";
import { PRIORITIES } from "@/features/tasks/lib/priority";

/** The new-task form. `project_key` only counts where the person picks the project. */
export const newTaskSchema = z.object({
  title: z.string().trim().min(1, "newTask.errors.title").max(TASK_TITLE_MAX_LENGTH),
  project_key: z.string().nullable(),
  status: z.enum(BOARD_COLUMNS),
  assignee_ids: z.array(z.string()).max(MAX_ASSIGNEES),
  priority: z.enum(PRIORITIES),
  due_on: z.string().nullable(),
});
export type NewTaskInput = z.input<typeof newTaskSchema>;
export type NewTaskOutput = z.output<typeof newTaskSchema>;

export const NEW_TASK_DEFAULTS: NewTaskInput = {
  title: "",
  project_key: null,
  status: "todo",
  assignee_ids: [],
  priority: "none",
  due_on: null,
};

/** Server field errors, by the form field they belong to. */
export const NEW_TASK_SERVER_FIELDS = {
  title: "title",
  project_key: "project_key",
  status: "status",
  assignee_ids: "assignee_ids",
  priority: "priority",
  due_on: "due_on",
} as const;
